import { FiltersAggregateItemType } from '@/interfaces/filters.interfaces';

import type { FiltersParametersType } from '../types';

import flattenFiltersAggregateValues from './flattenFiltersAggregateValues';

const makeFiltersAggregateItem = (
  data: Record<string, unknown>,
  parameters: FiltersParametersType,
) => {
  const aggregateValues = flattenFiltersAggregateValues(data);

  const filters = {
    id: `${+new Date()}`,
    envId: parameters.envId,
    spaceId: parameters.spaceId,
    collectionId: parameters.collectionId,
    data: aggregateValues,
  } as FiltersAggregateItemType;

  return filters;
};

export default makeFiltersAggregateItem;
